/* eslint-disable flowtype/no-types-missing-file-annotation */
import React from 'react';

export type Props = {
    scratchpadLink: React.ComponentType;
};

export const TripBoardLink = ({scratchpadLink}) => {
    return scratchpadLink;
};
